export const typeMaterialSheetMetal =
    [
        {
            value: 'Aluminum', title: "Aluminum", name: 'aluminum',
        },
        {
            value: "Cold Rolled Steel", title: "Cold Rolled Steel", name: 'coldRolledSteel',
        },
        {
            value: "Stainless Steel", title: "Stainless Steel", name: 'stainlessSteel',
        },
        {
            value: "Galvanneal", title: "Galvanneal", name: 'galvanneal',
        },
        {
            value: "Copper", title: "Copper", name: 'copper',
        },
        {
            value: "Other", title: "Other", name: 'Other',
        },
    ]

export const typeMaterialSheetMetalAluminum =
    [

        {
            title: `0.250" | 6.35 mm`,
        },
        {
            title: `0.188" | 4.78 mm`,
        },
        {
            title: `8 gauge	0.1285" | 3.26 mm`,
        },
        {
            title: `10 gauge 0.102" | 2.59mm`,
        },
        {
            title: `11 gauge 0.091" | 2.31 mm`,
        },
        {
            title: `12 gauge 0.081" | 2.06 mm`,
        },
        {
            title: `14 gauge 0.064" | 1.63 mm`,
        },
        {
            title: `16 gauge 0.051" | 1.30 mm`,
        },
        {
            title: `18 gauge 0.040" | 1.02 mm`,
        },
        {
            title: `20 gauge 0.032" | 0.81 mm`,
        },


    ]

export const typeMaterialSheetMetalColdRolledSteel =
    [
        {
            title: '11 gauge 0.120" | 3.05 mm',

        },
        {
            title: '12 gauge 0.105" | 2.67 mm',

        },
        {
            title: '13 gauge 0.090" | 2.29 mm',

        },
        {
            title: '14 gauge 0.075" | 1.91 mm',

        },
        {
            title: '16 gauge 0.060" | 1.52 mm',

        },
        {
            title: '18 gauge 0.048" | 1.22 mm',

        },
        {
            title: '20 gauge 0.036" | 0.91 mm',

        },
        {
            title: '22 gauge 0.030" | 0.76 mm',
        },



    ]

export const typeMaterialSheetMetalStainlessSteel =
    [

        {
            value: 0, title: `11 gauge 0.120" | 3.05mm`,
        },
        {
            value: 1, title: `12 gauge 0.109" | 2.78mm`,
        },
        {
            value: 2, title: `14 gauge 0.078" | 1.98mm`,
        },
        {
            value: 3, title: `16 gauge 0.063" | 1.59mm`,
        },
        {
            value: 4, title: `18 gauge 0.050" | 1.27mm`,
        },
        {
            value: 5, title: `20 gauge 0.038" | 0.95mm`,
        },
        {
            value: 6, title: `22 gauge 0.031" | 0.79mm`,
        },
        {
            value: 7, title: `24 gauge 0.025" | 0.64mm`,
        },

    ]
export const typeMaterialSheetMetalGalvanneal =
    [

        {
            "id": 0, title: `14 gauge 0.078" | 1.98mm`,
        },
        {
            "id": 1, title: `16 gauge 0.064" | 1.61mm`,
        },
        {
            "id": 2, title: `18 gauge 0.052" | 1.32mm`,
        },
        {
            "id": 3, title: `20 gauge 0.040" | 1.01mm`,
        },


    ]


export const typeMaterialSheetMetalCopper =
    [

        {
            "id": 0, title: `0.188" | 4.78mm`,
        },
        {
            "id": 1, title: `0.250" | 6.35mm`,
        },
        {
            "id": 2, title: `0.125" | 3.18mm`,
        },
        {
            "id": 3, title: `0.093" | 2.36mm`,
        },
        {
            "id": 4, title: `0.064" | 1.63mm`,
        },
    ];
